// extracted by mini-css-extract-plugin
module.exports = {"recoTag":"VIP_ProductRecommended__recoTag","recoText":"VIP_ProductRecommended__recoText","root":"VIP_ProductRecommended__root","icon":"VIP_ProductRecommended__icon"};